export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: NavigationItem[];
  isPermission?: boolean;
}

export const NavigationItems: NavigationItem[] = [
  {
    id: 'navigation',
    title: 'Navigation',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard',
        icon: 'feather icon-home',
        classes:'nav-item'
      },
    ],
  },
  {
    id: 'ui-component',
    title: 'Masters Modules',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'Masters',
        type: 'collapse',
        icon: 'feather icon-grid',
        children: [
          {
            id: 'button',
            title: 'Product',
            type: 'item',
            url: '/master/product',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Supplier',
            type: 'item',
            url: '/master/supplier',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Assemble Product',
            type: 'item',
            url: '/master/assemble-product',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Product Markup',
            type: 'item',
            url: '/master/product-markup',
            classes:'nav-item'
          }, 
          {
            id: 'button',
            title: 'Discount',
            type: 'item',
            url: '/master/discount',
            classes:'nav-item'
          },
          // {
          //   id: 'button',
          //   title: 'Discount Master',
          //   type: 'item',
          //   url: '/master/discount-master',
          //   classes:'nav-item'
          // },
          {
            id: 'basic',
            title: 'Vehicle',
            type: 'item',
            url: '/master/vehicle',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Currency',
            type: 'item',
            url: '/master/currency',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Unit of Measurement',
            type: 'item',
            url: '/master/unitofmeasurement',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Payment Terms',
            type: 'item',
            url: '/master/payment-terms',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Location',
            type: 'item',
            url: '/master/location',
            classes:'nav-item'
          },
          {
            id: 'button',
            title: 'Discount Type',
            type: 'item',
            url: '/master/discount-type',
            classes:'nav-item'
          },
        ],
      },
    ],
  },
  {
    id: 'ui-component',
    title: 'Mapping',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'Mapping',
        type: 'collapse',
        icon: 'feather icon-grid',
        children: [
          {
            id: 'button',
            title: 'Supplier Product',
            type: 'item',
            url: '/mapping/product-supply',
            classes:'nav-item'
          },
          // {
          //   id: 'button',
          //   title: 'Supplier Assembly',
          //   type: 'item',
          //   url: '/mapping/supplier-assembly',
          //   classes:'nav-item'
          // },
          {
            id: 'button',
            title: 'Product Vehicle',
            type: 'item',
            url: '/mapping/product-vehicle',
            classes:'nav-item'
          },
          // {
          //   id: 'button',
          //   title: 'Vehicle Engine',
          //   type: 'item',
          //   url: '/mapping/vehicle-engine',
          // },
        ],
      },
    ],
  },
  {
    id: 'ui-component',
    title: 'Requisition',
    type: 'group',
    icon: 'icon-group',
    children:[
    {
      id: 'basic',
      title: 'Requisition',
      type: 'collapse',
      icon: 'feather icon-codepen',
      children: [
        {
          id: 'button',
          title: 'Send Requisition',
          type: 'item',
          url: '/master/requisition',
          classes: 'nav-item',
        },
        {
          id: 'button',
          title: 'Received Requisition',
          type: 'item',
          url: '/master/received-requisition',
          classes: 'nav-item',
        },
        {
          id: 'button',
          title: 'Bulk Requisition',
          type: 'item',
          url: '/master/bulk-requisition',
          classes: 'nav-item',
        },
      ]
    }],
  },
  {
    id: 'ui-component',
    title: 'Purchase',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'Purchase',
        type: 'collapse',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'PurchaseOrder',
            title: 'Purchase Order',
            type: 'item',
            url: '/purchase/purchase-order',
            classes: 'nav-item',
          },
          {
            id: 'GRN',
            title: 'GRN',
            type: 'item',
            url: '/purchase/goods-return-note',
            classes: 'nav-item',
          },
          {
            id: 'PurchaseReturn',
            title: 'Purchase Return',
            type: 'item',
            url: '/purchase/purchase-return',
            classes: 'nav-item',
          },
        ],
      },
    ],
  },
  {
    id: 'ui-component',
    title: 'Report',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'Report',
        type: 'collapse',
        icon: 'feather icon-slack',
        children:[
          {
            id: 'Inventory',
            title: 'Inventory',
            type: 'item',
            url: '/report/inventory',
            classes: 'nav-item',
          },
          {
            id: 'Customer',
            title: 'Customer',
            type: 'item',
            url: '/report/customer-report',
            classes: 'nav-item',
          },
          {
            id: 'SalesMan',
            title: 'SalesMan',
            type: 'item',
            url: '/report/salesman-report',
            classes: 'nav-item',
          },
          {
            id: 'Purchase',
            title: 'Purchase',
            type: 'item',
            url: '/report/po-report',
            classes: 'nav-item',
          },
          {
            id: 'Purchase Return',
            title: 'Purchase Return',
            type: 'item',
            url: '/report/po-return-report',
            classes: 'nav-item',
          },
          {
            id:'Stock Count',
            title :'Stock Count',
            type :'item',
            url:'/report/stock-report',
            classes :'nav-item'
          },
          {
            id:'Supplier Product',
            title :'Supplier Product',
            type:'item',
            url:'/report/supplierProduct-report',
            classes:'nav-item'
          },
          {
            id:'Sales',
            title :'Sales',
            type:'item',
            url:'/report/sales-report',
            classes:'nav-item'
          },
          {
            id:'Sales Return',
            title :'Sales Return',
            type:'item',
            url:'/report/sales-return-report',
            classes:'nav-item'
          },
          {
            id:'Requisition',
            title :'Requisition',
            type:'item',
            url:'/report/requisition-report',
            classes:'nav-item'
          },
        ]
      }
    ]
  },
  {
    id: 'ui-component',
    title: 'POS',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'POS',
        type: 'collapse',
        icon: 'feather icon-target',
        children:[
          {
            id: 'Pos',
            title: 'POS',
            type: 'item',
            url: '/pos',
            classes: 'nav-item',
            //target: true
          },
          {
            id: 'AdvancePayment',
            title: 'Advance Payment',
            type: 'item',
            url: '/pos-main/advance-payment',
            classes: 'nav-item',
          },
          {
            id: 'CreditRequest',
            title: 'Credit Request',
            type: 'item',
            url: '/pos-main/credit-request',
            classes: 'nav-item',
          },
          {
            id: 'Customer',
            title: 'Customer',
            type: 'item',
            url: '/pos-main/customer',
            classes:'nav-item'
          },
          {
            id: 'sales-return',
            title: 'Sales-return',
            type: 'item',
            url: '/pos-main/sales-return',
            classes:'nav-item'
          },
          {
            id: 'Proforma List',
            title: 'Proforma List',
            type: 'item',
            url: '/pos-main/quotation',
            classes:'nav-item'
          },
          {
            id: 'Terminal List',
            title: 'Terminal',
            type: 'item',
            url: '/pos-main/terminal',
            classes:'nav-item'
          }
        ]
      }
    ]
  },
  {
    id: 'ui-component',
    title: 'User & Permission',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'User & Permission',
        type: 'collapse',
        icon: 'feather icon-layers',
        children: [
          {
            id: 'button',
            title: 'User',
            type: 'item',
            url: '/component/user',
          },
          {
            id: 'role-permission',
            title: 'Role',
            type: 'item',
            url: 'component/role-permission',
            classes: 'nav-item',
            // icon: 'feather icon-sidebar',
          },
        ],
      },
    ],
  },
  {
    id: 'ui-component',
    title: 'Settings',
    type: 'group',
    icon: 'icon-group',
    children: [
      {
        id: 'basic',
        title: 'Business Settings',
        type: 'collapse',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'button',
            title: 'Organization',
            type: 'item',
            url: '/setting/company-settings',
          },
          {
            id: 'button',
            title: 'Warehouse',
            type: 'item',
            url: '/setting/warehouse',
          },
          {
            id: 'button',
            title: 'Store',
            type: 'item',
            url: '/setting/store',
          },
          {
            id: 'button',
            title: 'Qty In Hand',
            type: 'item',
            url: '/setting/qty-in-hand',
          },
          {
            id: 'button',
            title: 'Invoice-Setting',
            type: 'item',
            url: '/setting/invoice-setting',
          },
        ],
      },
    ],
  },
];
